// A report title arrives HTML-escaped on the wire, so rendering it as markup hands the escape
// straight back and an escaped tag mounts as a live element. Decoding the escapes to characters
// and rendering the result as text shows the user's literal title while keeping any markup in it
// inert. `&amp;` is decoded last so an already-doubled escape (`&amp;lt;`) stays literal text.
const ENTITIES: Record<string, string> = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
}

export const decodeHtmlEntities = (text: string): string =>
  'string' === typeof text
    ? text.replace(/&(?:lt|gt|quot|#39);/g, match => ENTITIES[match] ?? match).replace(/&amp;/g, '&')
    : text
